// @flow

import { useMemo } from 'react';

import { CornerDownRight } from 'lucide-react';

import {
  type ProductError,
  type ProductId,
  selectOneProductById,
} from '@gandi/cart';

import { useAppSelector } from 'src/hooks';

import { ListRow } from '../../../ListRow';

import ProductItemBase from './ProductItemBase';
import { ErrorRow, TitleRow } from './Rows';
import { useRemoveProductHandler } from './modules';

type Props = {
  isCorporate?: boolean,

  deleteDisabled?: boolean,

  /** productId is used to be able to remove the product */
  productId?: ProductId,
  label: React.Node,
  detail?: React.Node,

  /** lighter text with a little info icon */
  info?: string,

  listRow?: React.Node,
  children?: React.Node,
  /** each error description will be shown */
  errors?: Array<ProductError>,
};

/** @deprecated Pass the `errors` to `ProductItem`
 * so we can remove this `ProductErrorItem` component.
 */
export default function ProductErrorItem({
  isCorporate = false,
  deleteDisabled,
  productId,
  label,
  detail,
  info,
  children,
  errors,
  listRow: ListRowComponent,
}: Props): React.MixedElement {
  const removeProduct = useRemoveProductHandler(productId);

  const productIdProps = useMemo(() => ({ productId }), [productId]);

  const product = useAppSelector(state =>
    // $FlowFixMe[incompatible-call] - productId can be undefined, but then no discount to display
    selectOneProductById(state, productIdProps),
  );

  return (
    <ProductItemBase
      header={
        <TitleRow
          deleteDisabled={deleteDisabled}
          isCorporate={isCorporate}
          handleRemoveAction={removeProduct}
          label={label}
          productType={product?.productType}
        />
      }
      footer={
        children || (
          <ErrorRow handleRemoveAction={removeProduct} errors={errors} />
        )
      }
    >
      {ListRowComponent ||
        (!!detail && (
          <ListRow
            intent="muted"
            icon={<CornerDownRight size={16} />}
            title={detail}
            options={info ? [info] : undefined}
            optionsArrow={false}
          />
        ))}
    </ProductItemBase>
  );
}
